import { IInstitution, IError, IQueryHookOptions } from '@comptia-sso/core';
import { useQuery } from 'react-query';

// Services.
import { getInstitutions } from 'services';

type UseInstitutions = [IInstitution[], IQueryHookOptions];

export const useInstitutions = (): UseInstitutions => {
  const {
    data = [] as IInstitution[],
    error,
    isError,
    isLoading,
  } = useQuery<IInstitution[], IError>(['institutions'], () =>
    getInstitutions(),
  );
  return [data, { error, isError, isLoading }];
};
